






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import axios from 'axios'
import { TournamentAPI } from '@/api/tournament'
import { VInput } from 'vuetify/lib'

// Create component
const FilePond = (vueFilePond as any)(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageValidateSize,
  FilePondPluginFileValidateSize,
  FilePondPluginImageCrop
)

@Component({
  components: {
    FilePond
  }
})
export default class VFormFileUploader extends VInput {
  @Prop({ type: String, default: 'image/jpeg, image/png' })
  readonly fileType!: any

  @Prop({ type: String, default: '' }) readonly label!: string
  @Prop({ type: String, default: '' }) readonly hint!: string
  @Prop({ type: String, default: '點擊或拖曳檔案到此處' })
  readonly labelIdle!: string

  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean
  @Prop({ type: Boolean, default: true }) readonly allowCrop!: boolean
  @Prop({ type: Boolean, default: true }) readonly allowPreview!: boolean
  @Prop({ type: String, default: '' }) readonly value!: string
  // @Prop({ type: Array, default: () => [] }) readonly value!: string[]

  myFiles: any[] = []
  filesUploaded: string[] = []

  handleFilePondInit() {
    this.parseValue()
  }

  @Watch('filesUploaded')
  onFileUploaded() {
    this.$emit('input', this.filesUploaded[0] || '')
  }

  @Watch('value')
  onValueChanged() {
    this.parseValue()
  }

  parseValue() {
    if (!this.value || !this.value.length) return

    this.myFiles = [
      {
        source: this.value,
        options: {
          type: 'local'
        }
      }
    ]
  }

  get tournamentId() {
    return this.$route.params.tournamentId || 'none'
  }

  get server() {
    return {
      load: (source: any, load: any) => {
        fetch(source)
          .then(res => res.blob())
          .then(load)
      },
      process: async (
        fieldName: string,
        file: any,
        metadata: any,
        load: Function,
        error: Function,
        progress: Function,
        abort: Function,
        transfer: any,
        options: any
      ) => {
        /* store file somewhere and call `load` when done */

        // fieldName is the name of the input field
        // file is the actual file object to send
        const formData = new FormData()
        formData.append(fieldName, file)

        // related to aborting the request
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        const token = this.$route.query.token
        // the request itself
        try {
          const response = await TournamentAPI.uploadUserGeneratedContent(
            this.tournamentId,
            formData,
            {
              cancelToken: source.token,
              onUploadProgress: e => {
                // updating progress indicator
                progress(e.lengthComputable, e.loaded, e.total)
              },
              headers: token
                ? {
                    Authorization: 'Bearer ' + token
                  }
                : undefined
            }
          )

          if (response.data && response.data.payload) {
            // passing the file id to FilePond
            load(response.data.payload)
            if (this.multiple) {
              this.filesUploaded.push(response.data.payload)
            } else {
              this.filesUploaded = [response.data.payload]
            }
          }
        } catch (err) {
          if (axios.isCancel(err)) {
            console.log('Request canceled', err.message)
          } else {
            // handle error
            error('Fail to upload file')
          }
        }

        // Setup abort interface
        return {
          abort: () => {
            source.cancel('Operation canceled by the user.')
          }
        }
      },
      fetch: null,
      revert: null
    }
  }
}
